import { CommonModule } from '@angular/common';
import { FeatureNeededModule } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.module';
import { ConfigModule } from 'NewAngular/config/config.module';
import { CascadingDropdownModule } from 'NewAngular/features/components/dropdowns/cascading-dropdown/cascading-dropdown.module';
import { LoadingSymbolModule } from 'NewAngular/features/components/loaders/loading-symbol/loading-symbol.module';
import { ModalBaseModule } from 'NewAngular/features/components/modals/modal-base/modal-base.module';
import { DisabledModule } from 'NewAngular/features/directives/disabled/disabled.module';
import { IconModule } from 'NewAngular/features/directives/icon/icon.module';
import { HoldingsDatePickerInlineModule } from 'SecuritiesApp/ts/features/holdings-date-picker-inline/holdings-date-picker-inline.module';
import * as i0 from "@angular/core";
export class HoldingsHistoryTableModule {
}
HoldingsHistoryTableModule.ɵfac = function HoldingsHistoryTableModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || HoldingsHistoryTableModule)(); };
HoldingsHistoryTableModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: HoldingsHistoryTableModule });
HoldingsHistoryTableModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
        ConfigModule,
        IconModule,
        HoldingsDatePickerInlineModule,
        DisabledModule,
        LoadingSymbolModule,
        CascadingDropdownModule,
        ModalBaseModule,
        FeatureNeededModule] });
